import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { UcBlockableDirective } from './uc-blockable.directive'
import { MbDataPreviewIdDirective } from './data-preview-id-directive/mb-data-preview-id.directive'
import { MbHoverDirective } from './hover-directive/mb-hover.directive'
import { MbDomChangeDirective } from './dom-change-directive/mb-dom-change.directive'
import { MbInViewportDirective } from './in-viewport-directive/mb-in-viewport.directive'
import { MbInnerHtmlRenderedDirective } from './mb-inner-html-rendered.directive.ts/mb-inner-html-rendered.directive'
import { CmsInnerHtmlDirective } from './cms-inner-html-directive/cms-inner-html.directive'
import { SwipeDirective } from './mb-swipe/swipe.directive'
import { MbAccordionRowChangeDirective } from './accordion-row-change-directive/mb-accordion-row-change.directive'

@NgModule({
  declarations: [
    MbDataPreviewIdDirective,
    MbHoverDirective,
    MbDomChangeDirective,
    MbInnerHtmlRenderedDirective,
    MbInViewportDirective,
    CmsInnerHtmlDirective,
    MbAccordionRowChangeDirective,
    SwipeDirective,
    UcBlockableDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    MbDataPreviewIdDirective,
    MbHoverDirective,
    MbDomChangeDirective,
    MbInnerHtmlRenderedDirective,
    MbInViewportDirective,
    CmsInnerHtmlDirective,
    MbAccordionRowChangeDirective,
    SwipeDirective,
    UcBlockableDirective
  ],
})

export class CmsDirectivesModule {
}
